module.exports = require("./lib/babel/polyfill");



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel/~/babel-core/polyfill.js
 ** module id = 213
 ** module chunks = 0
 **/